import React, {useState, useEffect, Fragment} from "react";
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import {setAssignQuotePopupSearchText} from "../../../actions/assignPopupFunctions";
import AssignQuotePopupSearch from "./assignQuotePopupSearch";
import JsonApi from "../../../api/jsonApi";
import LoadingSpinner from "../../ui/loadingSpinner";
import AssignQuoteCustomersList from "./assignQuoteCustomersList";
import AssignQuoteEmployeesList from "./assignQuoteEmployeesList";
import AssignQuotePopupContentHoc from "./assignQuotePopupContentHoc";
import {setEmployeesList} from "../../../actions/userFunctions";
import {IS_OFFLINE_MODE} from "../../../config";

const AssignQuotePopupContent = (props) => {

  const [salesPersons, setSalesPersons] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [responseReceived, setResponseReceived] = useState(false);
  const {isActive, assignQuotePopupSearchText, setEmployeesList, changeContext, assignQuoteOfflineCustomers,
    assignQuoteOfflineEmployees, hideEmployeesList} = props;

  const getCustomersAndEmployees = () => {
    if (IS_OFFLINE_MODE) {
      setSalesPersons(assignQuoteOfflineEmployees);
      setEmployeesList(assignQuoteOfflineEmployees);
      setCustomers(assignQuoteOfflineCustomers);
      setResponseReceived(true);
      return false
    }
    JsonApi.getCustomersAndEmployees()
      .then((response) => {
        if (response && response.data) {
          const empList = response.data.employees.filter(employee => employee.fullName);
          setSalesPersons(empList);
          setEmployeesList(empList);
          setCustomers(response.data.clients.filter(client => client.fullName && client.email));
        }
        setResponseReceived(true);
        console.log("getCustomersAndEmployees response", response);
      })
      .catch((error) => {
        setResponseReceived(true);
        console.error(error);
      })
  };

  useEffect(() => {
    getCustomersAndEmployees();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!responseReceived) {
    return (
      <div className={"ass ass--content" + (isActive ? " ass--active" : "")}>
        <LoadingSpinner/>
      </div>
    )
  }

  let customersList = customers;
  let employeesList = salesPersons;
  if (assignQuotePopupSearchText) {
    const testString = assignQuotePopupSearchText.toLowerCase();
    employeesList = salesPersons.filter(salesPerson => {
      return salesPerson.fullName.toLowerCase().includes(testString)
    });
    customersList = customers.filter(customer => {
      return customer.fullName.toLowerCase().includes(testString) || customer.email.toLowerCase().includes(testString)
    })
  }

  return (
    <div className={"ass ass--content" + (isActive ? " ass--active" : "")}>
      <AssignQuotePopupSearch/>
      <AssignQuotePopupContentHoc hideEmployeesList={hideEmployeesList}>
        {(contentDimensions) => (
          <Fragment>
            <AssignQuoteEmployeesList employeesList={employeesList}
                                      hideEmployeesList={hideEmployeesList}
                                      contentDimensions={contentDimensions}/>
            <AssignQuoteCustomersList customersList={customersList}
                                      hideEmployeesList={hideEmployeesList}
                                      contentDimensions={contentDimensions}
                                      changeContext={changeContext}/>
          </Fragment>
        )}
      </AssignQuotePopupContentHoc>
    </div>
  )
};

AssignQuotePopupContent.propTypes = {
  isActive: PropTypes.bool.isRequired,
  changeContext: PropTypes.func,
  hideEmployeesList: PropTypes.bool,
};

const mapStateToProps = (store) => {
  const {assignQuotePopupSearchText, assignQuoteOfflineCustomers, assignQuoteOfflineEmployees} = store.assignQuoteState;
  return {
    assignQuotePopupSearchText,
    assignQuoteOfflineCustomers,
    assignQuoteOfflineEmployees,
    windowWidth: store.serverState.windowWidth,
  };
};

const mapDispatchToProps = {
  setAssignQuotePopupSearchText,
  setEmployeesList
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(AssignQuotePopupContent)
)
